const RESELLER_BADGE_MAP = {
  1: {
    label: 'Reseller I',
    background:
      'linear-gradient(135deg, rgba(104, 109, 224, 0.95), rgba(72, 52, 212, 0.92))',
    border: 'rgba(255, 255, 255, 0.16)',
    shadow: 'rgba(104, 109, 224, 0.24)',
  },
  2: {
    label: 'Reseller II',
    background:
      'linear-gradient(135deg, rgba(235, 87, 87, 0.95), rgba(242, 153, 74, 0.92))',
    border: 'rgba(255, 255, 255, 0.16)',
    shadow: 'rgba(242, 153, 74, 0.24)',
  },
  3: {
    label: 'Reseller III',
    background:
      'linear-gradient(135deg, rgba(15, 32, 39, 0.95), rgba(44, 83, 100, 0.92))',
    border: 'rgba(255, 255, 255, 0.18)',
    shadow: 'rgba(125, 211, 252, 0.24)',
  },
} as const

export function BadgeReseller({ resellerLevel }: { resellerLevel: number }) {
  if (!resellerLevel) {
    return null
  }

  const currentBadge =
    RESELLER_BADGE_MAP[resellerLevel as keyof typeof RESELLER_BADGE_MAP]

  if (!currentBadge) {
    return null
  }

  return (
    <span
      className="inline-flex h-4 shrink-0 items-center justify-center rounded-full px-1.5 text-[7px] font-bold uppercase tracking-[0.03em] text-white align-middle"
      style={{
        background: currentBadge.background,
        border: `1px solid ${currentBadge.border}`,
        boxShadow: `0 2px 8px ${currentBadge.shadow}`,
        fontFamily: 'Nunito, sans-serif',
        lineHeight: 1,
      }}
    >
      <span style={{ position: 'relative', top: '1px' }}>{currentBadge.label}</span>
    </span>
  )
}
